import React from 'react';
import { Flex, Text } from 'onefaceui-react-components';
import PropTypes from 'prop-types';

import { getResourceTo } from 'react/utils/utils';

function ActivityCenterHeader({ totalNotifications, newNotifications }) {
  return (
    <Flex
      data-testid="activityCenter-header"
      justifyContent="space-between"
      alignItems="center"
      className="activityCenterHeader"
    >
      <Flex flexDirection="column" className="textContainer">
        <Text type="primary" className="title" weight="bold">
          {getResourceTo('activityCenter.title')}
        </Text>
        <Text type="neutral" className="total">
          {newNotifications > 0 && (
            <Text type="neutral" className="total" asChild>
              <span>
                {`${newNotifications} ${getResourceTo('default.button.new')}, `}
              </span>
            </Text>
          )}
          {`${totalNotifications} ${getResourceTo('driver.balance.total.string')}`}
        </Text>
      </Flex>
    </Flex>
  );
}

ActivityCenterHeader.propTypes = {
  totalNotifications: PropTypes.number,
  newNotifications: PropTypes.number
};

ActivityCenterHeader.defaultProps = {
  totalNotifications: 0,
  newNotifications: 0
};

export { ActivityCenterHeader };
